import HelpCenterCategoriesFeature from 'app/features/HelpCenter/HelpCenterCategoriesFeature'

import HeroSection from './components/HeroSection'

const HelpCenterMainView = () => {
  return (
    <>
      <HeroSection />

      <HelpCenterCategoriesFeature />
    </>
  )
}

export default HelpCenterMainView
